import ClickAndCollectCutOffPassedModal from './ClickAndCollectCutOffPassedModal';

export default ClickAndCollectCutOffPassedModal;
